module.exports = __webpack_public_path__ + "img/ease_reg_flow.3da2971.png";